import React from 'react';
// import {NavLink, Link } from 'react-router-dom'
import { useMenu } from '../../../context/MenuContext';
import logo from '../../../assets/images/logo.png';


function Header() {
    const userDetails = useMenu();
    return (
        <>
         <nav className="main-header navbar navbar-expand navbar-white navbar-light">
            <ul className="navbar-nav">
                <li className="nav-item">
                    <div className="brand-link brand-link-header d-flex justify-between items-center">
                        <a className="nav-link" data-widget="pushmenu" href="#" role="button"><i className="fas fa-bars" /></a>
                        <img src={logo} alt="AdminLTE Logo" className="brand-image" />
                    </div>
                </li>
            </ul>
            <ul className="navbar-nav ml-auto">
                <li className="nav-item">
                <div className="user-panel d-flex items-center">
                    <div className="info">
                        <a className="d-block">{userDetails.userDetails.userFullName}</a>
                        <span>{userDetails.userDetails.userDesignation}</span>
                    </div>
                </div>
                </li>
            </ul>
        </nav>

        </>
    );
  }
  
  export default Header;